<template>
    <!-- 手机CARD部 -->
    <div class="md:hidden" v-loading="loading" :style="{'height': isStandalone ? 'calc(100vh - 242px)' : 'auto'}">
        <div v-if="!isStandalone" class="flex flex-wrap gap-4">
            <el-card style="width: 100%; border: 2px solid #d1d5db; border-radius: 10px;"
                v-for="item in (!isStandalone ? tableData : data)" :key="item.inventory_id">

                <div class="flex justify-between">
                    <div class="flex pt-1.5">
                        <div v-if="item.check_result1 === 1" class="h-3 w-3 border-2 border-[#E63415] rounded-sm mr-1"></div>
                        <div v-else-if="item.check_result1 === 2" class="h-3 w-3 bg-[#E63415] rounded-sm mr-1"></div>
                        <div v-else class="h-3 w-3 bg-gray-400 rounded-sm mr-1"></div>

                        <div v-if="item.check_result2 === 1" class="h-3 w-3 border-2 border-[#FF6600] rounded-sm mr-1"></div>
                        <div v-else-if="item.check_result2 === 2" class="h-3 w-3 bg-[#FF6600] rounded-sm mr-1"></div>
                        <div v-else class="h-3 w-3 bg-gray-400 rounded-sm mr-1"></div>

                        <div v-if="item.check_result3 === 1" class="h-3 w-3 border-2 border-[#FFDE0A] rounded-sm mr-1"></div>
                        <div v-else-if="item.check_result3 === 2" class="h-3 w-3 bg-[#FFDE0A] rounded-sm mr-1"></div>
                        <div v-else class="h-3 w-3 bg-gray-400 rounded-sm mr-1"></div>

                        <div v-if="item.check_result4 === 1" class="h-3 w-3 border-2 border-[#1EC79D] rounded-sm mr-1"></div>
                        <div v-else-if="item.check_result4 === 2" class="h-3 w-3 bg-[#1EC79D] rounded-sm mr-1"></div>
                        <div v-else class="h-3 w-3 bg-gray-400 rounded-sm mr-1"></div>

                        <div v-if="item.check_result5 === 1" class="h-3 w-3 border-2 border-[#14CCCC] rounded-sm mr-1"></div>
                        <div v-else-if="item.check_result5 === 2" class="h-3 w-3 bg-[#14CCCC] rounded-sm mr-1"></div>
                        <div v-else class="h-3 w-3 bg-gray-400 rounded-sm mr-1"></div>

                        <div v-if="item.check_result6 === 1" class="h-3 w-3 border-2 border-[#4167F0] rounded-sm mr-1"></div>
                        <div v-else-if="item.check_result6 === 2" class="h-3 w-3 bg-[#4167F0] rounded-sm mr-1"></div>
                        <div v-else class="h-3 w-3 bg-gray-400 rounded-sm mr-1"></div>
                    </div>
                    <div>
                        <span class="material-symbols-outlined cursor-pointer"
                            @click="handleEditButton(item)">
                            edit_square
                        </span>
                        <span class="material-symbols-outlined cursor-pointer ml-2"
                            @click="handleAlarmButton(item)">
                            alarm
                        </span>
                        <span v-if="isAuthForTransfer.valueOf()"
                            class="material-symbols-outlined cursor-pointer ml-2"
                            @click="handleTransferInventoryButton(item)">
                            trolley
                        </span>
                        <span class="material-symbols-outlined cursor-pointer ml-2"
                            @click="handleDeleteButton(item)">
                            delete
                        </span>
                    </div>
                </div>

                <el-row align="middle">
                    <el-col :span="19">
                        <div class="flex flex-col">
                            <div>保管日: {{ formatDate(item.storage_date!) }}</div>
                            <div :class="{ 'text-red-500': isExpired(item.expiration_date) }">
                                有効期限: {{ formatDate(item.expiration_date) }}                        
                            </div>
                            
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="flex justify-end items-baseline cursor-pointer" @click="handleClickQuantityButton(item)">
                            <span class="text-2xl">{{ item.quantity }}</span>
                            <span v-if="item.material_unit" class="text-sm text-gray-500 ml-1">{{ item.material_unit }}</span>
                        </div>
                    </el-col>
                </el-row>

                <div v-if="item.images" class="h-[160px] mt-2" align="center">
                    <CarouselLoading v-model="item.images" height="160px" />
                </div>
            </el-card>
        </div>

        <div v-else style="overflow-y: auto; height: calc(100vh - 242px)">
            <div class="flex flex-wrap gap-4 p-4">
                <el-card style="width: 100%; border: 2px solid #d1d5db; border-radius: 10px"
                    v-for="item in (!isStandalone ? tableData : data)" :key="item.inventory_id">
                    <div class="flex flex-col justify-between">
                        <div>{{ item.organization_name }}</div>
                        <div>{{ item.department_name }}</div>
                    </div>

                    <div class="flex flex-col justify-between">
                        <div>{{ item.material_name }}</div>
                        <div>{{ item.category_name }}</div>
                    </div>

                    <div class="flex justify-between">
                        <div class="flex pt-1.5">
                            <div v-if="item.check_result1 === 1" class="h-3 w-3 border-2 border-[#E63415] rounded-sm mr-1"></div>
                            <div v-else-if="item.check_result1 === 2" class="h-3 w-3 bg-[#E63415] rounded-sm mr-1"></div>
                            <div v-else class="h-3 w-3 bg-gray-400 rounded-sm mr-1"></div>

                            <div v-if="item.check_result2 === 1" class="h-3 w-3 border-2 border-[#FF6600] rounded-sm mr-1"></div>
                            <div v-else-if="item.check_result2 === 2" class="h-3 w-3 bg-[#FF6600] rounded-sm mr-1"></div>
                            <div v-else class="h-3 w-3 bg-gray-400 rounded-sm mr-1"></div>

                            <div v-if="item.check_result3 === 1" class="h-3 w-3 border-2 border-[#FFDE0A] rounded-sm mr-1"></div>
                            <div v-else-if="item.check_result3 === 2" class="h-3 w-3 bg-[#FFDE0A] rounded-sm mr-1"></div>
                            <div v-else class="h-3 w-3 bg-gray-400 rounded-sm mr-1"></div>

                            <div v-if="item.check_result4 === 1" class="h-3 w-3 border-2 border-[#1EC79D] rounded-sm mr-1"></div>
                            <div v-else-if="item.check_result4 === 2" class="h-3 w-3 bg-[#1EC79D] rounded-sm mr-1"></div>
                            <div v-else class="h-3 w-3 bg-gray-400 rounded-sm mr-1"></div>

                            <div v-if="item.check_result5 === 1" class="h-3 w-3 border-2 border-[#14CCCC] rounded-sm mr-1"></div>
                            <div v-else-if="item.check_result5 === 2" class="h-3 w-3 bg-[#14CCCC] rounded-sm mr-1"></div>
                            <div v-else class="h-3 w-3 bg-gray-400 rounded-sm mr-1"></div>

                            <div v-if="item.check_result6 === 1" class="h-3 w-3 border-2 border-[#4167F0] rounded-sm mr-1"></div>
                            <div v-else-if="item.check_result6 === 2" class="h-3 w-3 bg-[#4167F0] rounded-sm mr-1"></div>
                            <div v-else class="h-3 w-3 bg-gray-400 rounded-sm mr-1"></div>
                        </div>
                        <div>
                            <span class="material-symbols-outlined cursor-pointer"
                                @click="handleEditButton(item)">
                                edit_square
                            </span>
                            <span class="material-symbols-outlined cursor-pointer ml-2"
                                @click="handleAlarmButton(item)">
                                alarm
                            </span>
                            <span v-if="isAuthForTransfer.valueOf()"
                                class="material-symbols-outlined cursor-pointer ml-2"
                                @click="handleTransferInventoryButton(item)">
                                trolley
                            </span>
                            <span class="material-symbols-outlined cursor-pointer ml-2"
                                @click="handleDeleteButton(item)">
                                delete
                            </span>
                        </div>
                    </div>

                    <el-row align="middle">
                        <el-col :span="19">
                            <div class="flex flex-col">
                                <div>保管日: {{ formatDate(item.storage_date!) }}</div>
                                <div :class="{ 'text-red-500': isExpired(item.expiration_date) }">
                                    有効期限: {{ formatDate(item.expiration_date) }}                        
                                </div>
                                
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="flex justify-end items-baseline cursor-pointer" @click="handleClickQuantityButton(item)">
                                <span class="text-2xl">{{ item.quantity }}</span>
                                <span v-if="item.material_unit" class="text-sm text-gray-500 ml-1">{{ item.material_unit }}</span>
                            </div>
                        </el-col>
                    </el-row>

                    <div v-if="item.images" class="h-[160px] mt-2" align="center">
                        <CarouselLoading v-model="item.images" height="160px" />
                    </div>
                </el-card>
            </div>
        </div>
    </div>

    <!-- 表格模式 -->
    <div class="hidden md:block w-full" :class="{ 'nested-table': !isStandalone }">
        <!-- 表格模式 -->
        <el-table 
            :data="(!isStandalone ? tableData : data)" 
            :height="tableHeight"
            v-loading="loading" 
            row-key="inventory_id"
            :show-header="isStandalone">

            <el-table-column label="詳細" width="80" align="center">
                <template #default="scope">
                    <el-button
                        class="w-12"
                        type="info"
                        style="background-color: #b7b7b7;"
                        text
                        bg
                        @click="handleEditButton(scope.row)">
                        <span>詳細</span>
                    </el-button>
                </template>
            </el-table-column>

            <el-table-column v-if="!isStandalone" prop="blank" label="" width="100" />
            <el-table-column v-if="isStandalone" prop="organization_name" label="組織" width="120" />
            <el-table-column v-if="isStandalone" prop="department_name" label="部署" width="120">
                <template #header>
                    <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('department_name')">
                        <span>{{ getSortLabel('department_name') }}</span>
                        <el-icon class="ml-1 flex-shrink-0">
                            <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'department_name' }">
                                {{ getSortIcon('department_name') }}
                            </span>
                        </el-icon>
                    </div>
                </template>
            </el-table-column>
            <el-table-column v-if="isStandalone" prop="category_name" label="カテゴリ" width="100">
                <template #header>
                    <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('category_name')">
                        <span>{{ getSortLabel('category_name') }}</span>
                        <el-icon class="ml-1 flex-shrink-0">
                            <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'category_name' }">
                                {{ getSortIcon('category_name') }}
                            </span>
                        </el-icon>
                    </div>
                </template>
            </el-table-column>
            <el-table-column v-if="isStandalone" prop="material_name" label="アイテム名">
                <template #header>
                    <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('material_name')">
                        <span>{{ getSortLabel('material_name') }}</span>
                        <el-icon class="ml-1 flex-shrink-0">
                            <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'material_name' }">
                                {{ getSortIcon('material_name') }}
                            </span>
                        </el-icon>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="storage_date" label="保管日" width="200">
                <template #header>
                    <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('storage_date')">
                        <span>{{ getSortLabel('storage_date') }}</span>
                        <el-icon class="ml-1 flex-shrink-0">
                            <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'storage_date' }">
                                {{ getSortIcon('storage_date') }}
                            </span>
                        </el-icon>
                    </div>
                </template>
                <template #default="scope">
                    <span v-if="!isStandalone">保管日: </span>{{ formatDate(scope.row.storage_date) }}
                </template>
            </el-table-column>
            <el-table-column prop="expiration_date" label="有効期限" width="200">
                <template #header>
                    <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('expiration_date')">
                        <span>{{ getSortLabel('expiration_date') }}</span>
                        <el-icon class="ml-1 flex-shrink-0">
                            <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'expiration_date' }">
                                {{ getSortIcon('expiration_date') }}
                            </span>
                        </el-icon>
                    </div>
                </template>
                <template #default="scope">
                    <span :class="{ 'text-red-500': isExpired(scope.row.expiration_date) }">
                        <span v-if="!isStandalone">有効期限: </span>{{ formatDate(scope.row.expiration_date) }}                        
                    </span>
                </template>
            </el-table-column>
            
            <el-table-column v-if="!isStandalone" prop="blank" label="" />

            <el-table-column prop="quantity" label="在庫数" width="100" header-align="center" align="right">
                <template #header>
                    <div class="flex items-center cursor-pointer whitespace-nowrap" @click="handleSort('quantity')">
                        <span>{{ getSortLabel('quantity') }}</span>
                        <el-icon class="ml-1 flex-shrink-0">
                            <span class="material-symbols-outlined text-sm" :class="{ 'text-blue-500': sortField === 'quantity' }">
                                {{ getSortIcon('quantity') }}
                            </span>
                        </el-icon>
                    </div>
                </template>
                <template #default="scope">
                    <span>{{ scope.row.quantity }}</span>
                    <span v-if="scope.row.material_unit" class="text-sm text-gray-500 ml-1">{{ scope.row.material_unit }}</span>
                </template>
            </el-table-column>

            <el-table-column prop="" label="画像" width="150" align="center">
                <template #default="scope">
                    <el-row align="middle">
                        <template v-if="scope.row.images">
                            <template v-for="image in getImgUrls(scope.row.images)" :key="image">
                                <ImgLoading :model-value="image" class="thumbnail mr-1" />
                            </template>
                        </template>
                    </el-row>
                </template>
            </el-table-column>
            <el-table-column prop="" label="アラート状況" width="110" align="center">
                <template #default="scope">
                    <AlertStatusIndicators :item="scope.row" />
                </template>
            </el-table-column>

            <el-table-column label="アラート" width="52" align="center">
                <template #default="scope">
                    <span class="material-symbols-outlined cursor-pointer mt-2"
                        @click="handleAlarmButton(scope.row)">
                        alarm
                    </span>
                </template>
            </el-table-column>

            <el-table-column v-if="isAuthForTransfer.valueOf()" label="払い出し" width="52" align="center">
                <template #default="scope">
                    <span class="material-symbols-outlined cursor-pointer mt-2"
                        @click="handleTransferInventoryButton(scope.row)">
                        trolley
                    </span>
                </template>
            </el-table-column>
            
            <el-table-column label="削除" width="52" align="center">
                <template #default="scope">
                    <span class="material-symbols-outlined cursor-pointer mt-2"
                        @click="handleDeleteButton(scope.row)">
                        delete
                    </span>
                </template>
            </el-table-column>
        </el-table>

    </div>

    <!-- 分页组件 -->
    <div v-if="!isStandalone && data.length > INVENTORY_CONSTANTS.DETAIL_LEVEL.PAGE_SIZE" class="flex w-full flex-col md:flex-row md:justify-between mt-4">
        <div class="md:ml-10">
            <div v-if="data.length > INVENTORY_CONSTANTS.DETAIL_LEVEL.EXCEED_RANGE" class="flex items-center">
                <el-icon color="#E6A23C" :size="24">
                    <WarnTriangleFilled />
                </el-icon>
                <span>在庫の検索結果が{{ INVENTORY_CONSTANTS.DETAIL_LEVEL.EXCEED_RANGE }}件を超えています。</span>
            </div>
        </div>

        <div>
            <div class="hidden md:flex items-center mb-4 mr-3">
                <div class="mr-5">在庫総計 {{ data.length }} 件</div>
                <el-pagination 
                    v-model:current-page="itemCurrentPage" 
                    v-model:page-size="itemPageSize"
                    layout="prev, pager, next"
                    :total="data.length" 
                    @size-change="handleItemSizeChange" 
                    @current-change="handleItemCurrentChange" 
                />
            </div>
            

            <div class="md:hidden flex justify-end">
                <el-pagination 
                    v-model:page-size="itemPageSize"
                    layout="prev, pager, next" 
                    :total="data.length"
                    @current-change="handleItemCurrentChange" 
                />
            </div>
        </div>
    </div>

    <!-- Quantity Edit Drawer (Mobile Only) -->
    <QuantityEditDrawer
        v-model="quantityDrawerVisible"
        :quantity="editingItem?.quantity || 0"
        @confirm="handleQuantityConfirm"
        @cancel="handleQuantityCancel"
    />
</template>

<script lang="ts">
import { defineComponent, computed, ref, PropType, onMounted } from 'vue';
import moment from 'moment';
import ImgLoading from '@/components/common/ImgLoading.vue';
import CarouselLoading from '@/components/common/CarouselLoading.vue';
import AlertStatusIndicators from './AlertStatusIndicators.vue';
import QuantityEditDrawer from '@/components/common/QuantityEditDrawer.vue';
import { AlarmInfo, ConstantInfo, InventoryInfo } from './type';
import { ROLES } from '@/config/constants';
import { WarnTriangleFilled } from '@element-plus/icons-vue';
import { INVENTORY_CONSTANTS } from '@/config/constants';

export default defineComponent({
    name: 'DetailLevelInventoryList',
    components: {
        ImgLoading,
        CarouselLoading,
        AlertStatusIndicators,
        QuantityEditDrawer,
        WarnTriangleFilled
    },
    props: {
        data: {
            type: Array as PropType<InventoryInfo[]>,
            required: true,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        isStandalone: {
            type: Boolean,
            default: false, // 默认不是独立使用（嵌套使用）
        },
        currentPage: {
            type: Number,
            default: 1,
        },
        pageSize: {
            type: Number,
            default: 10,
        },
        totalRecords: {
            type: Number,
            default: 0,
        },
    },
    emits: ['edit', 'delete', 'alarm', 'quantityUpdate', 'sort', 'size-change', 'current-change', 'transferInventory'],
    setup(props, { emit }) {
        const tableData = ref<InventoryInfo[]>([]);
        const itemCurrentPage = ref<number>(1);
        const itemPageSize = ref<number>(INVENTORY_CONSTANTS.DETAIL_LEVEL.PAGE_SIZE);
        // 用户权限
        const isAuthForTransfer = (localStorage.getItem('role') === ROLES.SYSTEM || (localStorage.getItem('role') === ROLES.ADMIN && localStorage.getItem('is_head') === '1'));
        
        // Quantity Edit Drawer state (Mobile only)
        const quantityDrawerVisible = ref(false);
        const editingItem = ref<InventoryInfo | null>(null);

        // 排序相关状态
        const sortField = ref<string>('material_name'); // 当前排序字段
        const sortOrder = ref<'asc' | 'desc'>('asc'); // 当前排序方向

        // 排序配置
        const sortConfig = {
            'material_name': {
                label: 'アイテム名',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            'quantity': {
                label: '在庫数',
                type: 'number' as const,
                defaultOrder: 'desc' as const
            },
            'storage_date': {
                label: '保管日',
                type: 'date' as const,
                defaultOrder: 'desc' as const
            },
            'expiration_date': {    
                label: '有効期限',
                type: 'date' as const,
                defaultOrder: 'asc' as const
            },
            'department_name': {
                label: '部署',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            },
            'category_name': {
                label: 'カテゴリ',
                type: 'string' as const,
                defaultOrder: 'asc' as const
            }
        };

        onMounted(() => {
            if (!props.isStandalone) {
                tableData.value = props.data;
                calculatePagination();
            }
        });

        // 计算表格高度，展开时使用自适应高度
        const tableHeight = computed(() => {
            if (props.isStandalone) {
                // 显示表头时，使用固定高度撑满容器
                return 'calc(100vh - 260px)';
            } else {
                // 不显示表头时，使用自适应高度
                return 'auto';
            }
        });

        const handleEditButton = (item: any) => {
            emit('edit', item);
        };

        const handleAlarmButton = (item: any) => {
            emit('alarm', item);
        };

        const handleTransferInventoryButton = (item: any) => {
            emit('transferInventory', item);
        };

        const handleDeleteButton = (item: any) => {
            emit('delete', item);
        };

        // Quantity Edit Drawer handlers (Mobile only)
        const handleClickQuantityButton = (item: InventoryInfo) => {
            editingItem.value = item;
            quantityDrawerVisible.value = true;
        };

        const handleQuantityConfirm = (newQuantity: number) => {
            if (!editingItem.value) {
                return;
            }

            // Emit quantity update event to parent - parent will handle API call, loading, and refresh
            emit('quantityUpdate', { item: editingItem.value, newQuantity });
            
            // Close drawer
            quantityDrawerVisible.value = false;
            editingItem.value = null;
        };

        const handleQuantityCancel = () => {
            editingItem.value = null;
            quantityDrawerVisible.value = false;
        };
        

        const formatDate = (date: string) => {
            return moment(date).format('YYYY/MM/DD');
        };

        const isExpired = (date: string) => {
            return moment(date).isBefore(moment(), 'day');
        };

        const getImgUrls = (images: string) => {
            let bufImages: string[] = images.split(',');
            return bufImages;
        };

        // 处理排序
        const handleSort = (field: string) => {
            if (sortField.value === field) {
                // 如果点击的是当前排序字段，切换排序方向
                sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc';
            } else {
                // 如果点击的是新字段，使用该字段的默认排序方向
                sortField.value = field;
                sortOrder.value = sortConfig[field as keyof typeof sortConfig]?.defaultOrder || 'asc';
            }
            // 触发排序事件，让父组件处理
            emit('sort', { field: sortField.value, order: sortOrder.value });
        };

        // 获取排序图标
        const getSortIcon = (field: string) => {
            if (sortField.value !== field) {
                return 'unfold_more'; // 未排序状态
            }
            return sortOrder.value === 'asc' ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
        };

        // 获取排序字段的标签
        const getSortLabel = (field: string) => {
            const config = sortConfig[field as keyof typeof sortConfig];
            return config ? config.label : field;
        };

        // 分页处理方法
        const handleSizeChange = (size: number) => {
            emit('size-change', size);
        };

        const handleCurrentChange = (page: number) => {
            emit('current-change', page);
        };

        const handleItemSizeChange = (size: number) => {
            itemPageSize.value = size;
            calculatePagination();
        };

        const handleItemCurrentChange = (page: number) => {
            itemCurrentPage.value = page;
            calculatePagination();
        };

        // 前端分页计算（支持多项目排序）
        const calculatePagination = () => {
            // 计算分页
            const startIndex = (itemCurrentPage.value - 1) * itemPageSize.value;
            const endIndex = startIndex + itemPageSize.value;
            
            tableData.value = props.data.slice(startIndex, endIndex);
        };
        
        return {
            isAuthForTransfer,
            tableHeight,
            handleEditButton,
            handleAlarmButton,
            handleDeleteButton,
            handleTransferInventoryButton,
            handleSort,
            getSortIcon,
            getSortLabel,
            handleSizeChange,
            handleCurrentChange,
            sortField,
            sortOrder,
            formatDate,
            isExpired,
            getImgUrls,
            INVENTORY_CONSTANTS,
            tableData,
            itemCurrentPage,
            itemPageSize,
            handleItemSizeChange,
            handleItemCurrentChange,
            handleClickQuantityButton,
            handleQuantityConfirm,
            handleQuantityCancel,
            quantityDrawerVisible,
            editingItem,
            ROLES,
        };
    },
});
</script>

<style scoped>
.thumbnail {
    width: 30px;
    height: 30px;
    object-fit: cover;
}

.custom-title {
    background-color: #f5f5f5;
    padding: 0 16px;
    font-weight: bold;
    border-bottom: 1px solid #e4e7ed;
}

/* 嵌套表格样式 */
.nested-table {
    width: calc(100% - 8px);
    margin-left: 8px;
}

/* 覆盖展开单元格的默认内边距 */
:deep(.el-table__expanded-cell) {
    padding: 0 !important;
}

:deep(.el-table__expanded-cell .cell) {
    padding: 0 !important;
}

:deep(.el-table__cell.el-table__expanded-cell) {
    padding: 0 !important;
}

.cursor-pointer {
    cursor: pointer;
}

.big-font-input :deep(.el-input__inner) {
    font-size: 24px;
}

.quantity-editor {
    border-radius: 6px;
}

/* 排序表头样式 */
.sort-header {
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s;
    white-space: nowrap;
    display: flex;
    align-items: center;
}

.sort-header:hover {
    background-color: #f5f7fa;
}

/* 确保表头内容不换行 */
:deep(.el-table .el-table__header-wrapper .el-table__header th) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

</style> 